import type { FC, ReactElement } from "react";
import React, { useMemo } from "react";

import { getChildrenRecord } from "../../../../utils/react";

import type { SelectionCellProps } from "../../types";

import classes from "./SelectionCellControl.styl";

const SELECTION_CELL_CONTROL_TEST_ID = "selection-cell-control-test-id";

export interface ISelectionCellControlMain
    extends Pick<SelectionCellProps, "state"> {}

export interface ISelectionCellControl {
    /** Текст который будет читать скринридер когда фокус будет на SelectionCell.Control */
    ariaLabel: string;
    children: ReactElement;
}
/**
 * children должен содержать в себе толко один обязательный элемент из трех (Checkbox, Radio, Switch)
 * Это достигается:
 * 1. С помобщью типизации children. Мы делаем свойство обязательным и даем возможность передать туда только один элемент
 * 2. В рантайме. С помощью метода getChildrenRecord делаем нужные компоненты optionalRequired
 * */
export const SelectionCellControl: FC<ISelectionCellControl> = (props) => {
    const { ariaLabel, children } = props as ISelectionCellControl &
        ISelectionCellControlMain;

    const { Switch, Checkbox, Radio } = useMemo(
        () =>
            getChildrenRecord(children, "", {
                Switch: {
                    props: {
                        "aria-label": ariaLabel,
                    },
                    optionalRequired: true,
                },
                Checkbox: {
                    props: {
                        "aria-label": ariaLabel,
                    },
                    optionalRequired: true,
                },
                Radio: {
                    props: {
                        "aria-label": ariaLabel,
                    },
                    optionalRequired: true,
                },
                Unknown: {
                    skipElement: true,
                },
            }),
        [children, ariaLabel],
    );

    return (
        <div
            className={classes["cell-control"]}
            data-tsid={SELECTION_CELL_CONTROL_TEST_ID}
        >
            {Checkbox}
            {Radio}
            {Switch}
        </div>
    );
};

SelectionCellControl.displayName = "SelectionCell.Control";

export default SelectionCellControl;
